import { cn } from "@/libraries/cn";
import Button from "@mui/material/Button";
import type { ButtonProps } from "@mui/material/Button";
import omit from "lodash/omit";

interface MultipleButtonFloatingProps {
	position?: React.CSSProperties["position"];
	className?: string;
	negativeButtonProps: ButtonProps & { label: string };
	positiveButtonProps: ButtonProps & { label: string };
}

const MultipleButtonFloating = (props: MultipleButtonFloatingProps) => {
	const {
		position = "fixed",
		className,
		negativeButtonProps,
		positiveButtonProps,
	} = props;
	return (
		<div
			className={cn(
				"bg-white shadow bottom-0 inset-x-0 z-10 py-3",
				position,
				className,
			)}
		>
			<div className="wrapper">
				<div className="container">
					<div className="grid grid-cols-2 gap-4">
						<Button
							fullWidth
							type="button"
							color="primary"
							variant="outlined"
							size="large"
							className={cn(
								"!rounded-full !h-12",
								negativeButtonProps.className,
							)}
							{...omit(negativeButtonProps, ["label"])}
						>
							{negativeButtonProps.label}
						</Button>
						<Button
							fullWidth
							type="submit"
							color="primary"
							variant="contained"
							size="large"
							className={cn(
								"!rounded-full !h-12",
								positiveButtonProps.className,
							)}
							{...omit(positiveButtonProps, ["label"])}
						>
							{positiveButtonProps.label}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MultipleButtonFloating;
